import type { GuideSettingsState } from './types/guide-settings-state'
import type { SpreadGuideSettingsLoaded } from './types/spread-guide-settings-loaded'

function parseTimestampMs(raw: string | undefined): number | null {
  if (typeof raw !== 'string' || raw.trim() === '') return null
  const ms = Date.parse(raw)

  return Number.isFinite(ms) ? ms : null
}

function hasIndividualGuideSettings(
  settings: SpreadGuideSettingsLoaded | null
): settings is SpreadGuideSettingsLoaded {
  return settings != null && settings.columns > 0 && settings.rows > 0
}

export function resolveEffectiveGuideSettings(args: {
  defaultGuideSettings: GuideSettingsState | null
  spreadGuideSettings: SpreadGuideSettingsLoaded | null
  planbookUpdatedAt?: string
  spreadUpdatedAt?: string
}): GuideSettingsState | null {
  const { defaultGuideSettings, spreadGuideSettings, planbookUpdatedAt, spreadUpdatedAt } = args

  if (hasIndividualGuideSettings(spreadGuideSettings)) {
    const spreadMs = parseTimestampMs(spreadUpdatedAt)
    const planbookMs = parseTimestampMs(planbookUpdatedAt)

    // Preserve explicit spread overrides unless planbook is provably newer.
    if (spreadMs == null || planbookMs == null || planbookMs <= spreadMs) {
      return spreadGuideSettings
    }
  }

  return defaultGuideSettings
}
